import React, { FC } from 'react';
import Head from 'next/head';

// This layout is for displaying a single child component with no additional nav or breadcrumbs etc.

interface EmptyLayoutProps {
  title: string;
  description: string;
}

const EmptyLayout: FC<EmptyLayoutProps> = ({
  children,
  title = 'This is the default title',
  description = 'This is the default description',
}) => (
  <>
    <Head>
      <title>{title} | Domain Developer Portal</title>
      <meta name="description" content={description} />
    </Head>
    <div>{children}</div>
  </>
);

export default EmptyLayout;
